<ejs-dialog
  id="call-log-modal"
  data-qa="genesys-call-log_modal"
  #Dialog
  isModal="true"
  width="80%"
  [visible]="true"
  [allowDragging]="true"
  [header]="title | translate"
  [showCloseIcon]="true"
  (beforeClose)="beforeClose($event)"
  (close)="close($event)"
  (open)="onOpen($event)"
>
  <ng-template #content>
    <!-- #region CALL LOG SEARCH VIEW -->
    <call-log-search-view
      #CallLogSearch
      *ngIf="callLogOrigin === 'Default'"
      [genesysData]="genesysData"
      [callerPhone]="phoneNumber"
      [searchData]="searchData"
      (openCallLogReport)="swapCallLogView($event)"
    ></call-log-search-view>
    <!-- #endregion -->
    <!-- #region CALL LOG REPORT VIEW -->
    <call-log-report-view
      #CallLogReport
      *ngIf="callLogOrigin !== 'Default'"
      [ngClass]="{ hidden: isPCIPalOpen }"
      [callSubType]="callSubType"
      [callType]="callType"
      [customerId]="customerId"
      [genesysData]="genesysData"
      [isEditMode]="isEditMode"
      [paymentNotification]="paymentNotification"
      [paymentRequirementNotifications]="paymentRequirementNotifications"
      [paymentProcessed]="paymentProcessed"
      [reminders$]="reminders$"
      (saveReportData)="saveReportData($event)"
      (openPCIPal)="openPCIPal()"
      (cancelEvent)="cancelEvent($event)"
    ></call-log-report-view>
    <!-- #endregion -->
    <horizon-payment-getaway
      *ngIf="isPCIPalOpen"
      [paymentData]="paymentData"
      [isPCIPalOpen]="isPCIPalOpen"
      (paymentFinished)="paymentFinished($event)"
    ></horizon-payment-getaway>
  </ng-template>
</ejs-dialog>
